import { standsPopupHtml, trupuriPopupHtml } from './popups';
import type { IcasPmtilesConfig } from './IcasPmtilesLayer';

/**
 * Per-build override; falls back to a Vercel-static path. Set the env
 * var (e.g. to a Cloudflare R2 public URL) when the .pmtiles gets too
 * large for Vercel free-tier comfort.
 */
const STANDS_URL =
  (import.meta.env.VITE_ICAS_PMTILES_URL as string | undefined) ??
  '/data/icas/stands.pmtiles';

export const STANDS_CONFIG: IcasPmtilesConfig = {
  key: 'stands',
  url: STANDS_URL,
  dataLayer: 'stands',
  // Deep forest green at low opacity — 89k polygons cover most of
  // Moldova's forested area; high opacity would be a wall of color.
  fill: '#15803d',
  fillOpacity: 0.2,
  stroke: '#14532d',
  strokeWidth: 0.5,
  minZoom: 8,
  strokeFromZoom: 11,
  // Paint rule is active up to z24 so the layer survives any user
  // zoom-in past the bake limit (protomaps will over-zoom the z16
  // tiles).
  paintMaxZoom: 24,
  maxDataZoom: 16,
  popupBuilder: standsPopupHtml,
};

export const TRUPURI_CONFIG: IcasPmtilesConfig = {
  key: 'trupuri',
  url: '/data/icas/trupuri.pmtiles',
  dataLayer: 'trupuri',
  // Teal — distinct from the stands green and from user parcels (also
  // green). Higher fill opacity than stands because trupuri are fewer
  // and bigger; users need to see them clearly.
  fill: '#14b8a6',
  fillOpacity: 0.18,
  stroke: '#0f766e',
  strokeWidth: 1,
  // Render at every zoom — the paint rule's lower/upper bounds are
  // wide open so the symbolizer never gates off the user. Tippecanoe
  // was baked at -Z 5 -z 14 (rebake 2026-05-15 without
  // --drop-densest-as-needed, so all 3,601 polygons survive at every
  // baked zoom). protomaps over-zooms z14 tiles for z15+, so users
  // who zoom in past z14 still see the layer.
  minZoom: 0,
  strokeFromZoom: 0,
  paintMaxZoom: 24,
  maxDataZoom: 14,
  popupBuilder: trupuriPopupHtml,
};
